
export default function Gallery() {
  const galleryItems = [
    {
      image: 'https://public.readdy.ai/ai/img_res/35e5d0559bafabb231a19dc70c9ef194.jpg',
      style: 'FADE',
      caption: 'Precision Fade'
    },
    {
      image: 'https://readdy.ai/api/search-image?query=Classic%20taper%20haircut%20with%20crisp%20edge%20up%20on%20Black%20man%2C%20professional%20barbering%20work%2C%20warm%20golden%20tones%2C%20simple%20clean%20background%20highlighting%20the%20haircut%20details%2C%20side%20profile%20view&width=600&height=700&seq=gallery002&orientation=portrait',
      style: 'TAPER',
      caption: 'Classic Taper'
    },
    {
      image: 'https://readdy.ai/api/search-image?query=Well%20maintained%20natural%20locs%20hairstyle%20on%20African%20American%20man%2C%20healthy%20twisted%20locks%2C%20professional%20grooming%2C%20warm%20lighting%2C%20simple%20neutral%20background%20showcasing%20the%20loc%20style%20and%20texture&width=600&height=700&seq=gallery003&orientation=portrait',
      style: 'LOCS',
      caption: 'Loc Maintenance'
    },
    {
      image: 'https://readdy.ai/api/search-image?query=Sharp%20beard%20trim%20and%20lineup%20on%20Black%20man%2C%20perfectly%20sculpted%20facial%20hair%2C%20professional%20grooming%2C%20warm%20golden%20lighting%2C%20simple%20clean%20background%20highlighting%20beard%20details%20and%20precision&width=600&height=700&seq=gallery004&orientation=portrait',
      style: 'BEARD',
      caption: 'Beard Sculpting'
    },
    {
      image: 'https://readdy.ai/api/search-image?query=Modern%20high%20top%20fade%20haircut%20on%20African%20American%20man%2C%20clean%20sharp%20edges%2C%20contemporary%20barbershop%20style%2C%20warm%20tones%2C%20simple%20neutral%20background%20showcasing%20the%20elevated%20cut%20style&width=600&height=700&seq=gallery005&orientation=portrait',
      style: 'HIGH TOP',
      caption: 'High Top Fade'
    },
    {
      image: 'https://readdy.ai/api/search-image?query=Fresh%20buzz%20cut%20with%20crisp%20lineup%20on%20Black%20man%2C%20clean%20minimalist%20style%2C%20professional%20barbering%2C%20warm%20lighting%2C%20simple%20clean%20background%20highlighting%20the%20precise%20edges%20and%20clean%20cut&width=600&height=700&seq=gallery006&orientation=portrait',
      style: 'BUZZ CUT',
      caption: 'Clean Buzz'
    }
  ];

  return (
    <section id="gallery" className="py-24 bg-neutral-950">
      <div className="max-w-7xl mx-auto px-6">
        <div className="mb-16">
          <h2 className="text-6xl md:text-7xl font-thin text-white mb-4">GALLERY</h2>
          <p className="text-stone-500 text-base">See Our Work</p>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {galleryItems.map((item, index) => (
            <div key={index} className="group cursor-pointer">
              <div className="bg-neutral-900 border border-neutral-800 rounded-2xl p-5 hover:border-amber-500/30 transition-all">
                <div className="w-full h-96 rounded-xl overflow-hidden mb-4">
                  <img
                    src={item.image}
                    alt={item.caption}
                    className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                  />
                </div>
                <p className="text-center text-white font-semibold text-lg mb-2">{item.caption}</p>
                <p className="text-center text-amber-500 font-bold text-sm tracking-wider">{item.style}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <button className="border border-stone-600 text-stone-300 px-8 py-3 rounded-full text-sm font-semibold hover:bg-amber-500 hover:border-amber-500 hover:text-black transition-all whitespace-nowrap cursor-pointer">
            VIEW MORE →
          </button>
        </div>
      </div>
    </section>
  );
}
